// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1S33i","amount":"Amount_amount__2eOBl","tip":"Amount_tip__39JxL","tipHeader":"Amount_tipHeader__3rWak","tipsWrap":"Amount_tipsWrap__1oA_n"};